/* eslint-disable max-len */
import { ALERT_CONDITION_TYPES, METRIC_NAMES } from '@config/Consts';
import { i18nHandlers } from './i18n';

const milliHash = {
  seconds: 1000,
  minutes: 1000 * 60,
  hours: 1000 * 60 * 60,
};

const i18nHash = {
  hours: 'time_unit_hour_long',
  minutes: 'time_unit_minute_long',
  seconds: 'time_unit_second_long',
};

/**
 * @param amount
 * @param unit
 * @return {number}
 */
function evaluateTime(amount, unit) {
  return amount * milliHash[unit];
}

/**
 * @param metrics
 * @param metricId
 * @return {null}
 */
function findMetricValue(metrics, metricId) {
  return metrics.find(item => item.metric === metricId).score || null;
}

/**
 * @param metrics
 * @param metricId
 * @return {null}
 */
function getMetric(metrics, metricId) {
  return metrics.find(item => item.metric === metricId) || null;
}


/**
 * @name checkAlertsConfigured
 * @description Checks if alerts configured
 * @param alertsData
 * @return {{pendingAgentResponseRate: Boolean}}
 */
function checkAlertsConfigured(alertsData) {
  const { pendingAgentResponseRate } = alertsData;
  return {
    [METRIC_NAMES.AGENT_VIEW_PENDING_RATE]: !!pendingAgentResponseRate,
  };
}

/**
 * @name getIsAlertActiveForStandardMetric
 * @description Checks if alert should be shown for standard metric (only below and above types)
 * @param alert
 * @param metricScore
 * @return {{isAlert: boolean, value}}
 */
function getIsAlertActiveForStandardMetric(alert, metricScore) {
  const { value, condition } = alert;
  if (condition === ALERT_CONDITION_TYPES.BELOW) {
    return {
      isAlert: value > metricScore,
      value,
    };
  }
  return {
    isAlert: value < metricScore,
    value,
  };
}

export default {
  checkAlertsConfigured,
  getMetric,
  findMetricValue,
  evaluateTime,
  i18nHash,
  i18nHandlers,
  getIsAlertActiveForStandardMetric,
};
